import { memo, forwardRef } from 'react';

import useAvatarCircle from './useAvatarCircle';

interface IProps {
  name?: string;
  peerId?: string;
  avatarImgSize?: number;
  className?: string;
}

const AvatarCircle = forwardRef<HTMLImageElement, IProps>((props, ref) => {
  const { avatarSrc } = useAvatarCircle(props);

  return (
    <img
      ref={ref}
      src={avatarSrc}
      alt="avatar"
      className={props.className}
      style={{
        width: props.avatarImgSize ? `${props.avatarImgSize}px` : '40%',
        aspectRatio: '1',
        display: 'block',
        borderRadius: '50%',
        objectFit: 'cover',
      }}
    />
  );
});

export default memo(AvatarCircle);
